import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { IndicadoresAnalise } from '../../models/indicadores-analise.model';
import { IndicadoresPgAnaliseService } from '../../services/indicadores-pg-analise.service';
import { NavigationService } from '../../services/navigation.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-analise-edit',
  templateUrl: './detalhe-pg-indicadores-analise-edit.component.html',
  styleUrls: ['./detalhe-pg-indicadores-analise-edit.component.scss']
})
export class DetalhePgIndicadoresAnaliseEditComponent extends BaseFormComponent<IndicadoresAnalise> implements OnInit {

  idPgIndicador: number;
  analise: IndicadoresAnalise;
  actionLabel: string = 'Nova';
  type: string = '';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private myService: IndicadoresPgAnaliseService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.type = this.activatedRoute.snapshot.data['type'];
    this.list = this.activatedRoute.snapshot.data['list'];
    if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['ind_id']) {
      this.idPgIndicador = this.activatedRoute.snapshot.queryParams['ind_id'];
    }
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      ind_id: new FormControl(null),
      description: new FormControl('', [Validators.required]),
      ind_analysis_stat_id: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.audit = {
        pg_ind_analysis_id: this.entity.id
      }
    }
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', this?.type ?? 'agregador', 'indicadores', this.entity?.ind_id]);
    } else {
      this.navigation.back(['projetos', this?.type ?? 'agregador', 'indicadores', this.idPgIndicador]);
    }
  }

  getDataCreate(): IndicadoresAnalise {
    let data: IndicadoresAnalise;
    data = Object.assign({}, data, this.form.value);

    if (!this.entity?.id && this.idPgIndicador) {
      data.ind_id = this.idPgIndicador;
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Análise alterada com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', this?.type ?? 'agregador', 'indicadores', 'analise', res.id, 'editar']);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
